<div class="confirm-data-root" *transloco="let t">
  <app-carousel-register [migrating]="true"
                         [previousPageLabel]="t('previous-step')"
                         [finishLabel]="t('create-account')"
                         (finish)="confirmData()"
                         [pages]="carouselPages"
                         [firstPageLabel]="t('first-register-page-header')"
                         [secondPageLabel]="t('second-register-page-header')"
                         [thirdPageLabel]="t('third-register-page-header')"
                         [businessData]="businessData"
                         [equipmentData]="equipmentData"
                         [canEditEquipments]="false"
                         [businessRepresentative]="businessRepresentative"
                         [termsFormGroup]="termsFormGroup"
                         [recaptchaFormGroup]="recaptchaFormGroup"
                         [creatingAccount]="creatingAccount"
                         [errorMessage]="errorMessage">
  </app-carousel-register>
</div>
